import { forceRedirectToPath } from 'swag-common/business-logic/redirect-wrapper-state';
export const handleClick = () => () => {
  forceRedirectToPath('/what-we-offer');
};